import React, { useState } from "react";
import "./fuelLoadModal.css";
import Button from "../../Button/Button";

const labels = {
  fuelPumpBefore: 'Bomba (antes)',
  kmBeforePhoto: 'KM antes',
  tankBeforePhoto: 'Tanque (antes)',
  fuelPumpAfter: 'Bomba (después)',
  tankAfterPhoto: 'Tanque (después)',
  receiptPhoto: 'Ticket',
};

const sections = [
  { title: 'Fotos - Antes', keys: ['fuelPumpBefore', 'kmBeforePhoto', 'tankBeforePhoto'] },
  { title: 'Fotos - Después', keys: ['fuelPumpAfter', 'tankAfterPhoto'] },
  { title: 'Ticket', keys: ['receiptPhoto'] },
];

const FuelLoadModal = ({ fuelLoads, visible, onClose, username, route }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [rotation, setRotation] = useState(0);

  const rotateLeft = (e) => {
    e.stopPropagation();
    setRotation((r) => r - 90);
  };
  const rotateRight = (e) => {
    e.stopPropagation();
    setRotation((r) => r + 90);
  };
  const closeImageModal = (e) => {
    e.stopPropagation();
    setRotation(0);
    setSelectedImage(null);
  };

  if (!visible) return null;

  return (
    <>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-md-10">
            <div className="fuel-modal-overlay">
              <div className="fuel-modal">
                <div className="fuel-modal-header">
                  <h3>Datos de Gasolina</h3>
                  <h3>De: {username}</h3>
                  <h5>Con ID: {route?.routeId}</h5>
                  <Button
                    text="X"
                    color="red"
                    fill
                    action={onClose}
                    classNames="close-button"
                  />
                </div>
                <div className="fuel-modal-body">
                  {fuelLoads.map((fuel, idx) => (
                    <div key={idx} className="fuel-load-section">
                      <p><strong>Cantidad cargada:</strong> $ {fuel.amountCharged}</p>
                      {fuel.kmBefore && (
                        <p><strong>Kilómetros antes:</strong> {fuel.kmBefore}</p>
                      )}
                      {sections.map(({ title, keys }) => (
                        <React.Fragment key={title}>
                          <div className={`section-title${title === 'Fotos - Después' ? ' mt-3' : ''}`}>{title}</div>
                          <div className="row">
                            {keys.map((key) => (
                              fuel[key] && (
                                <div key={key} className="col-6">
                                  <p>{labels[key]}</p>
                                  <div
                                    className="fuel-img"
                                    style={{ backgroundImage: `url(${fuel[key]})` }}
                                    onClick={() => setSelectedImage(fuel[key])}
                                  />
                                </div>
                              )
                            ))}
                          </div>
                        </React.Fragment>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {selectedImage && (
        <div className="image-only-modal" onClick={closeImageModal}>
          <div className="image-controls" onClick={(e) => e.stopPropagation()}>
            <button onClick={rotateLeft}>⟲</button>
            <button onClick={rotateRight}>⟳</button>
            <button onClick={closeImageModal}>✕</button>
          </div>
          <div
            className="enlarged-image"
            style={{
              backgroundImage: `url(${selectedImage})`,
              transform: `rotate(${rotation}deg)`
            }}
          />
        </div>
      )}
    </>
  );
};

export default FuelLoadModal;